module.exports = __webpack_public_path__ + "media/images/pc/top/recommend_plan_photowedding@2x-435a046d2c9a23391279ea8f5000f2d7.webp";